<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-band-width`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 3l.743-1.857h.001l.008.004.02.008.071.029c.061.025.15.061.262.109a59.525 59.525 0 014.039 1.896c2.387 1.234 5.432 3.025 7.551 5.103C41.03 12.541 45 17.925 45 25c0 11.598-9.402 21-21 21S3 36.598 3 25c0-7.21 4.47-13.318 8.684-17 2.02-1.764 4.941-3.478 7.25-4.714a81.995 81.995 0 014.151-2.067l.068-.03.018-.01.008-.003L24 3zm-.82-1.824l.774-.348.789.315L24 3l-.82-1.824zM20.82 6.813a77.917 77.917 0 013.22-1.625l.377.166c.735.328 1.755.802 2.888 1.388 2.31 1.195 4.913 2.764 6.589 4.407C37.971 15.144 41 19.549 41 25c0 9.389-7.611 17-17 17S7 34.39 7 25c0-5.578 3.53-10.681 7.316-13.987 1.655-1.446 4.233-2.984 6.505-4.2zm3.745 25.45L36.328 20.5 33.5 17.672l-9.066 9.066-5.5-5L11.672 29 14.5 31.83l4.566-4.566 5.5 5z"/></svg>
</template>
<script>

export default {
  name: 'IconBandWidth',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
